import React from 'react';
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import './DocumentPicker.scss'

import { Fire, Popup, Tools } from '../../../services'

import FadeIn from 'react-fade-in';

interface Props {
  title: string;
  previewTitle?: string;
  value?: any;
  error: any;
  disabled?: boolean;
  onChange: (e: any) => void;
}
const DocumentPicker: React.FC<Props> = (props) => {

  const showFile = (title: string, url?: string) => {
    if (!url || url === '')
      return;
    Popup.show({
      type: 'component',
      settings: {
        title: props.previewTitle || 'Preview',
      },
      component: () => (
        <img alt="Picker file" style={{width: '80%', objectFit: 'contain'}} src={url} />
      )
    })
  }

  return (
    <div className="doc-picker">
      <h6 className="doc-title">{props.title}</h6>
      {props.error &&
        <div className="error-doc-message">{props.error}</div>
      }
      <div className="doc-content">
        <div className="doc-preview" onClick={() => showFile(props.title, props.value.url)}>
          {props.value && <img alt="Private id recto" src={props.value.url} />}
        </div>
        <div className={"custom-file"}>
          <input
            disabled={props.disabled}
            type="file"
            className={"custom-file-input"}
            onChange={(evt) => props.onChange(evt)}
            />
          <label className="custom-file-label">
            { (props.value) ? (
            <span>Document uploadé</span>
          ) : (
            <span>Choisir un fichier</span>
          )}
          </label>
        </div>
      </div>
    </div>
  );
}

export default DocumentPicker